export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/batchFileProcessor.833eda74.worker.js");
}
